import React, { useRef, useEffect } from 'react'

function MiniPayoff({ shortStrike, longStrike, netCredit }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas || !shortStrike || !longStrike || netCredit == null) return;
    const ctx = canvas.getContext('2d');
    const W = 300, H = 120;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = '#0a0a0c'; ctx.fillRect(0, 0, W, H);
    const nc = parseFloat(netCredit);
    const maxP = +(nc * 100).toFixed(0);
    const maxL = +((shortStrike - longStrike - nc) * 100).toFixed(0);
    const be = shortStrike - nc;
    const L = 6, R = 6, T = 10, B = 25;
    const pW = W - L - R, pH = H - T - B;
    const span = shortStrike - longStrike;
    const pMin = longStrike - span * 0.35, pMax = shortStrike + span * 0.9;
    const vMin = -(maxL + maxL * 0.1), vMax = maxP + maxP * 0.5;
    const px = p => L + (p - pMin) / (pMax - pMin) * pW;
    const py = v => T + (vMax - v) / (vMax - vMin) * pH;
    ctx.fillStyle = 'rgba(122,171,138,0.1)'; ctx.fillRect(px(be), T, W - R - px(be), py(0) - T);
    ctx.fillStyle = 'rgba(196,122,122,0.1)'; ctx.fillRect(L, py(0), px(be) - L, H - B - py(0));
    ctx.strokeStyle = 'rgba(240,237,230,0.2)'; ctx.lineWidth = 1; ctx.setLineDash([4,3]);
    ctx.beginPath(); ctx.moveTo(L, py(0)); ctx.lineTo(W-R, py(0)); ctx.stroke(); ctx.setLineDash([]);
    ctx.lineWidth = 2.5; ctx.lineJoin = 'round';
    ctx.strokeStyle = '#c47a7a'; ctx.beginPath(); ctx.moveTo(L, py(-maxL)); ctx.lineTo(px(longStrike), py(-maxL)); ctx.stroke();
    const g = ctx.createLinearGradient(px(longStrike), 0, px(shortStrike), 0);
    g.addColorStop(0, '#c47a7a'); g.addColorStop(1, '#7aab8a');
    ctx.strokeStyle = g; ctx.beginPath(); ctx.moveTo(px(longStrike), py(-maxL)); ctx.lineTo(px(be), py(0)); ctx.lineTo(px(shortStrike), py(maxP)); ctx.stroke();
    ctx.strokeStyle = '#7aab8a'; ctx.beginPath(); ctx.moveTo(px(shortStrike), py(maxP)); ctx.lineTo(W-R, py(maxP)); ctx.stroke();
    ctx.fillStyle = 'rgba(240,237,230,0.4)'; ctx.font = "8px 'Jost',sans-serif"; ctx.textAlign = 'center';
    ctx.fillText('$'+longStrike, px(longStrike), H-B+12);
    ctx.fillText('BE', px(be), H-B+12);
    ctx.fillText('$'+shortStrike, px(shortStrike), H-B+12);
  }, [shortStrike, longStrike, netCredit]);
  if (!shortStrike || !longStrike) return null;
  return <canvas ref={ref} width={300} height={120} style={{ borderRadius:'6px', display:'block', maxWidth:'100%' }} />;
}

export default MiniPayoff
